import { getFileMetaByIdFromCache } from 'gql/files/apollo'
import { useBrandTheme } from 'services/Branding/hooks'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getSection, isDisabledNavigation } from 'services/Store/Project/selectors'
import { useNavigationAction } from 'services/Store/Project/triggers'
import { COMPANY_DEFAULT_LOGO, getOriginalImageById } from 'utils/files'
import { testProps } from 'utils/test/qaData'

import { CourseHeaderLogoImage, CourseHeaderLogoStyled } from './styled'

interface ICourseHeaderLogoProps {
  projectLogoId?: string | null
  title?: string | null
  disabled?: boolean
}

const CourseHeaderLogo: React.FC<ICourseHeaderLogoProps> = ({ projectLogoId, title, disabled }) => {
  const cover = useProjectContext(getSection, { cover: true })
  const firstSection = useProjectContext(getSection, { first: true })
  const currentSection = useProjectContext(getSection)
  const firstSectionId = cover?.id || firstSection?.id
  const onNavigate = useNavigationAction()
  const isDisabledSidebarAndHome = useProjectContext(isDisabledNavigation)
  const theme = useBrandTheme()
  const logoData = getOriginalImageById(theme?.logoHeader || projectLogoId)
  const logo = getFileMetaByIdFromCache(String(theme?.logoHeader || projectLogoId || ''))
  const logoPath = logoData?.path || COMPANY_DEFAULT_LOGO
  const disabledNavigate = isDisabledSidebarAndHome || disabled || !firstSectionId

  const goFirstSection = () =>
    !disabledNavigate && onNavigate({ sectionId: firstSectionId, currentSection })

  return (
    <CourseHeaderLogoStyled
      {...testProps({ el: 'courseLogo', logo: logo?.id, title })}
      $active={!disabledNavigate}
      aria-label={disabledNavigate ? undefined : 'Go home page'}
      onClick={goFirstSection}
      role={disabledNavigate ? undefined : 'button'}
      tabIndex={disabledNavigate ? undefined : 0}
    >
      <CourseHeaderLogoImage alt='Logo' aria-hidden={!disabledNavigate} src={logoPath} />
    </CourseHeaderLogoStyled>
  )
}

export default CourseHeaderLogo
